import {observer} from 'mobx-react';
import {Select2} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {withDeleted} from 'shared/tools';
import _ from 'lodash';

const Department = observer(({viewModel}) => {
  const {uiState} = viewModel;

  if (uiState.massUpdate.readOnly && !viewModel.fields.get('departmentId').has('newValue')) {
    return (
      <div className='waterloo'>
        <FormattedMessage id='mass_updates.edit.Not Changed'/>
      </div>
    );
  }

  const departments = withDeleted(uiState.departments, viewModel.data.employee.department);
  const previousDepartment = viewModel.get('departmentId').get('oldValue') ?
    _.get(_.find(departments, {id: viewModel.get('departmentId').get('oldValue')}), 'name', '--') :
    '--';

  return (
    <div>
      <Select2
        searchable
        allowClear
        value={viewModel.get('departmentId').get('value')}
        disabled={viewModel.disabled}
        onChange={e => viewModel.set('departmentId', e.target.value)}
      >
        {departments.map(department => {
          return <option key={department.id} value={department.id}>{department.name}</option>;
        })}
      </Select2>
      <div className='jumbo mt1'>
        <FormattedMessage
          id={viewModel.disabled ? 'mass_updates.edit.PREVIOUS_VALUE' : 'mass_updates.edit.CURRENT_VALUE'}
          values={{
            value: previousDepartment
          }}
        />
      </div>
    </div>
  );
});

export default Department;
